/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** WeekdayEnum */
export enum WeekdayEnum {
  Monday = "Monday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
  Thursday = "Thursday",
  Friday = "Friday",
  Saturday = "Saturday",
  Sunday = "Sunday",
}

/** TrialAction */
export enum TrialAction {
  Approve = "approve",
  Reject = "reject",
  Extend = "extend",
  Delete = "delete",
}

/**
 * TitleChoices
 * Enum representing user titles
 */
export enum TitleChoices {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
}

/** TimetablePerformActionEnum */
export enum TimetablePerformActionEnum {
  Publish = "publish",
  Unpublish = "unpublish",
}

/** StaffJustificationStatus */
export enum StaffJustificationStatus {
  Pending = "pending",
  Submitted = "submitted",
  Expired = "expired",
  Closed = "closed",
}

/**
 * ResponsibleTypeEnum
 * Who is responsible for taking the register.
 *
 * Values:
 *     tutor: The group's tutor/teacher
 *     subject_teacher: The subject teacher for the period
 */
export enum ResponsibleTypeEnum {
  Tutor = "tutor",
  SubjectTeacher = "subject_teacher",
}

/** RegisterSessionEnum */
export enum RegisterSessionEnum {
  Am = "am",
  Pm = "pm",
}

/** PeriodTypeEnum */
export enum PeriodTypeEnum {
  Lesson = "Lesson",
  Registration = "Registration",
  Break = "Break",
  Activity = "Activity",
}

/** ParentJustificationStatus */
export enum ParentJustificationStatus {
  Pending = "pending",
  Submitted = "submitted",
  Expired = "expired",
  Closed = "closed",
}

/** ParentAttendanceStatus */
export enum ParentAttendanceStatus {
  Present = "present",
  Absent = "absent",
}

/** JustificationStatus */
export enum JustificationStatus {
  Pending = "pending",
  Submitted = "submitted",
  Closed = "closed",
  Resolved = "resolved",
  Rejected = "rejected",
  Expired = "expired",
}

/**
 * GroupType
 * Enum containing the types of groups supported
 */
export enum GroupType {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** GroupAggregateSortBy */
export enum GroupAggregateSortBy {
  RegisterDateAsc = "register_date-asc",
  RegisterDateDesc = "register_date-desc",
}

/**
 * FrequencyTypeEnum
 * Frequency type for attendance configuration.
 *
 * Values:
 *     am: Morning register only
 *     pm: Afternoon register only
 *     am_pm: Both morning and afternoon registers
 */
export enum FrequencyTypeEnum {
  Am = "am",
  Pm = "pm",
  AmPm = "am_pm",
}

/** FacilityTypeEnum */
export enum FacilityTypeEnum {
  Room = "room",
  Building = "building",
  Campus = "campus",
}

/**
 * ExportType
 * Output format for a file export (CSV, PDF, or JSON).
 */
export enum ExportType {
  Csv = "csv",
  Pdf = "pdf",
  Json = "json",
}

/**
 * AttendanceSessionEnum
 * Register session slot for a mark or grid row (AM or PM only).
 */
export enum AttendanceSessionEnum {
  Am = "am",
  Pm = "pm",
}

/** AttendanceFrequency */
export enum AttendanceFrequency {
  Am = "am",
  Pm = "pm",
  AmPm = "am_pm",
}

/** AssessmentEvaluationType */
export enum AssessmentEvaluationType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/**
 * AggregateSessionScope
 * Only the sessions this group runs, or every session its students have in the period.
 */
export enum AggregateSessionScope {
  Group = "group",
  All = "all",
}

/** AbsenceRequest */
export interface AbsenceRequest {
  /** Comment */
  comment: string;
  /**
   * Start
   * @format date
   */
  start: string;
  /**
   * End
   * @format date
   */
  end: string;
}

/** AddAttendanceEntriesForGroupRequest */
export interface AddAttendanceEntriesForGroupRequest {
  /**
   * Register Id
   * @format uuid
   */
  register_id: string;
  /** Relations */
  relations: AddAttendanceEntryForGroupRelation[];
  session?: AttendanceSessionEnum | null;
  /** Period Id */
  period_id?: string | null;
}

/** AddAttendanceEntryForGroupRelation */
export interface AddAttendanceEntryForGroupRelation {
  /**
   * Relation Id
   * @format uuid
   */
  relation_id: string;
  /**
   * Attendance Code Id
   * @format uuid
   */
  attendance_code_id: string;
  /** Text */
  text?: string | null;
  justification?: JustificationSave | null;
}

/**
 * AgeGroup
 * Age group (GAG) of a group — the group's configured age group, not member registrations.
 */
export interface AgeGroup {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  /** Order */
  order: number;
  /** Archived */
  archived: boolean;
}

/** AgeGroupEntryResponse */
export interface AgeGroupEntryResponse {
  age_group: AgeGroupPreviewResponse;
  /** Student Count */
  student_count: number;
  session: AttendanceSessionEnum | null;
  /** Per Period Enabled */
  per_period_enabled: boolean;
}

/**
 * AgeGroupFrequencyInput
 * An age group with its attendance frequency configuration.
 */
export interface AgeGroupFrequencyInput {
  /**
   * Id
   * Age group (SchoolProperty) ID
   * @format uuid
   */
  id: string;
  /** Frequency configuration for a single age group. */
  attendance_frequency: AttendanceFrequencyInput;
}

/**
 * AgeGroupFrequencyResponse
 * Age group with its attendance frequency configuration.
 */
export interface AgeGroupFrequencyResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  /** Order */
  order: number;
  /** Level Id */
  level_id?: string | null;
  attendance_frequency?: AttendanceFrequencyResponse | null;
}

/** AgeGroupPreviewCompositionResponse */
export interface AgeGroupPreviewCompositionResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  /** Order */
  order: number;
  frequency: AttendanceFrequency;
}

/** AgeGroupPreviewResponse */
export interface AgeGroupPreviewResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  /** Order */
  order: number;
  frequency: AttendanceFrequency;
}

/** AggregatedAssessmentsResponse */
export interface AggregatedAssessmentsResponse {
  /** Key */
  key: string;
  /** Rows */
  rows: AggregatedAssessmentsRow[];
}

/** AggregatedAssessmentsRow */
export interface AggregatedAssessmentsRow {
  /** Total */
  total: number;
  /**
   * Value
   * @format date
   */
  value: string;
}

/**
 * AllocationEntry
 * Allocation entry in a timetable.
 */
export interface AllocationEntry {
  /**
   * Group Id
   * @format uuid
   */
  group_id: string;
  /** Room Id */
  room_id: string | null;
}

/** ArchiveCodePreviewResponse */
export interface ArchiveCodePreviewResponse {
  /** Code To Delete */
  code_to_delete: string;
  /** Success */
  success: string;
}

/** ArchiveCodeResponse */
export interface ArchiveCodeResponse {
  /** Success */
  success: string;
}

/** AreaOfLearning */
export interface AreaOfLearning {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
}

/** AssessmentAverageResult */
export interface AssessmentAverageResult {
  /**
   * Assessment Id
   * UUID identifying the assessment
   * @format uuid
   */
  assessment_id: string;
  /**
   * Average Value
   * Average score as integer or null if no score_out_of or comment method is defined
   */
  average_value: number | null;
  /** Group Ids */
  group_ids: string[];
  /**
   * Group Type
   * Group type: 1 for Subject, 2 for TutorGroup
   */
  group_type: AssessmentAverageResultGroupTypeEnum;
  /** Assessment method */
  method: Method;
  /**
   * Subject Id
   * UUID identifying the subject
   */
  subject_id: string | null;
}

/**
 * AssessmentAverageSubjectResult
 * Per-subject_id average score as percentage (0-100). subject_id is None for tutor groups.
 */
export interface AssessmentAverageSubjectResult {
  /** Subject Id */
  subject_id: string | null;
  /** Average Score */
  average_score: number | null;
}

/** AssessmentEntriesForProfileResponse */
export interface AssessmentEntriesForProfileResponse {
  /** Results */
  results: AssessmentWithEntriesForProfile[];
  /** Count */
  count: number;
  /** Total Pages */
  total_pages: number;
  /** Next Page */
  next_page: number;
  /** Current Page */
  current_page: number;
  /** Previous Page */
  previous_page: number;
}

/** AssessmentEntriesForSchoolResponse */
export interface AssessmentEntriesForSchoolResponse {
  /** Results */
  results: AssessmentWithEntriesForSchool[];
  /** Count */
  count: number;
  /** Total Pages */
  total_pages: number;
  /** Next Page */
  next_page: number;
  /** Current Page */
  current_page: number;
  /** Previous Page */
  previous_page: number;
}

/** AssessmentEntryForMarkbook */
export interface AssessmentEntryForMarkbook {
  method: AssessmentEntryMethod;
  /** Score */
  score: number | null;
  /** Select List Option Id */
  select_list_option_id: string | null;
  /** Comment */
  comment: string | null;
  creator: EntryCreator | null;
  /** Assessment Id */
  assessment_id: string;
  group: GroupSummary;
  /**
   * Enterable And My Group
   * @default true
   */
  enterable_and_my_group?: boolean;
}

/** AssessmentEntryForProfileOverviewResponse */
export interface AssessmentEntryForProfileOverviewResponse {
  /** Group Type */
  group_type: number | null;
  /** Subject Id */
  subject_id: string | null;
  /** Subject Name */
  subject_name: string | null;
  /** Count */
  count: number | null;
}

/** AssessmentEntryMethod */
export interface AssessmentEntryMethod {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Type */
  type: number;
}

/** AssessmentForProfileData */
export interface AssessmentForProfileData {
  /**
   * Assessment Id
   * @format uuid
   */
  assessment_id: string;
  /** Assessment Name */
  assessment_name: string;
  /** Display Name */
  display_name: string;
  /**
   * Date
   * @format date
   */
  date: string;
  /** Subject Id */
  subject_id: string | null;
  /** Subject Name */
  subject_name: string | null;
  /** Group Type */
  group_type: number;
  /** Autogenerated */
  autogenerated: boolean;
  /** Evaluation Type */
  evaluation_type: number;
  area_of_learning: AreaOfLearning | null;
}

/** AssessmentInfoResponse */
export interface AssessmentInfoResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Status */
  status: number;
  /** Name */
  name: string;
  /** Display Name */
  display_name: string | null;
  /**
   * Assessment Date
   * @format date
   */
  assessment_date: string;
  /** Publish Date */
  publish_date: string | null;
  /** Generated From Report Id */
  generated_from_report_id: string | null;
  /** Autogenerated */
  autogenerated: boolean;
  /** Can Be Edited */
  can_be_edited: boolean;
  /** Groups */
  groups: SingleAssessmentGroupSummary[];
  /** Methods */
  methods: Method[];
  /** Reports */
  reports: ReportSummary[];
  recurring_state: RecurringState | null;
  area_of_learning: AreaOfLearning | null;
  /** Evaluation Type */
  evaluation_type: number;
}

/** AssessmentResponse */
export interface AssessmentResponse {
  /** Results */
  results: SingleAssessmentResponse[];
  /** Count */
  count: number;
  /** Total Pages */
  total_pages: number;
  /** Next Page */
  next_page: number;
  /** Current Page */
  current_page: number;
  /** Previous Page */
  previous_page: number;
}

/** AssessmentWithEntriesForProfile */
export interface AssessmentWithEntriesForProfile {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Status */
  status: number;
  /** Name */
  name: string;
  /** Display Name */
  display_name: string;
  /**
   * Assessment Date
   * @format date
   */
  assessment_date: string;
  /** Publish Date */
  publish_date?: string | null;
  /** Generated From Report Id */
  generated_from_report_id?: string | null;
  /** Autogenerated */
  autogenerated: boolean;
  /** Evaluation Type */
  evaluation_type: number;
  /** Methods */
  methods: MethodForMobile[];
  area_of_learning?: AreaOfLearning | null;
  staff_preview: SrcModulesAssessmentsInterfaceRestDtosAssesmentStaffPreview | null;
  group: GroupForAssessmentWithType;
  /** Entries */
  entries: EntryForProfile[];
}

/** AssessmentWithEntriesForSchool */
export interface AssessmentWithEntriesForSchool {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Status */
  status: number;
  /** Name */
  name: string;
  /** Display Name */
  display_name: string;
  /**
   * Assessment Date
   * @format date
   */
  assessment_date: string;
  /** Publish Date */
  publish_date?: string | null;
  /** Generated From Report Id */
  generated_from_report_id?: string | null;
  /** Autogenerated */
  autogenerated: boolean;
  /** Evaluation Type */
  evaluation_type: number;
  /** Methods */
  methods: Method[];
  area_of_learning?: AreaOfLearning | null;
  /** Groups */
  groups: SingleAssessmentGroupWithStudents[];
  /** Reports */
  reports: ReportSummary[];
  /** Enterable And My Group */
  enterable_and_my_group: boolean;
}

/** AssessmentsAverageResponse */
export interface AssessmentsAverageResponse {
  /**
   * Results
   * Array of average assessment results
   */
  results: AssessmentAverageResult[];
  /**
   * Average Results
   * Per-subject_id average score as percentage (0-100)
   */
  average_results?: AssessmentAverageSubjectResult[];
}

/** AssessmentsFiltersForProfile */
export interface AssessmentsFiltersForProfile {
  /** Subjects */
  subjects: SubjectForAssessmentFilters[];
}

/** AssessmentsForProfileResponse */
export interface AssessmentsForProfileResponse {
  /** Results */
  results: AssessmentForProfileData[];
  /** Count */
  count: number;
  /** Previous Page */
  previous_page: number;
  /** Current Page */
  current_page: number;
  /** Next Page */
  next_page: number;
  /** Total Pages */
  total_pages: number;
  filters: AssessmentsFiltersForProfile;
}

/** AttendanceAggregateCellMetaResponse */
export interface AttendanceAggregateCellMetaResponse {
  /** Day */
  day: number;
  /** Sessions */
  sessions: AttendanceSessionEnum[];
}

/** AttendanceAggregateEntryCommentResponse */
export interface AttendanceAggregateEntryCommentResponse {
  /** Text */
  text: string;
  creator: AttendanceAggregatePersonPreviewResponse;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** AttendanceAggregateJustificationResponse */
export interface AttendanceAggregateJustificationResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  status: StaffJustificationStatus;
  /** Parent Submissions */
  parent_submissions: JustificationSubmission[];
  /** Staff Reasons */
  staff_reasons: JustificationReason[];
  /** Staff Requests */
  staff_requests: JustificationRequest[];
}

/** AttendanceAggregateLatestChangeResponse */
export interface AttendanceAggregateLatestChangeResponse {
  author: AttendanceAggregatePersonPreviewResponse | null;
  /** Updated From Group Id */
  updated_from_group_id: string | null;
}

/** AttendanceAggregateLessonResponse */
export interface AttendanceAggregateLessonResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string | null;
  /** Order */
  order: number | null;
}

/** AttendanceAggregatePeriodResponse */
export interface AttendanceAggregatePeriodResponse {
  timetable_structure: AttendanceAggregateTimetableStructureResponse | null;
  lesson: AttendanceAggregateLessonResponse;
}

/** AttendanceAggregatePersonPreviewResponse */
export interface AttendanceAggregatePersonPreviewResponse {
  /** Given Name */
  given_name: string;
  /** Known As */
  known_as: string | null;
  /** Last Name */
  last_name: string;
  /**
   * Relation Id
   * @format uuid
   */
  relation_id: string;
  title: TitleChoices | null;
}

/** AttendanceAggregateRegisterGroupResponse */
export interface AttendanceAggregateRegisterGroupResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
}

/** AttendanceAggregateTimetableStructureResponse */
export interface AttendanceAggregateTimetableStructureResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
}

/** AttendanceCodeCountResponse */
export interface AttendanceCodeCountResponse {
  /** Attendance Code Id */
  attendance_code_id: string | null;
  /** Order */
  order: number;
  /** Count */
  count: number;
}

/** AttendanceCodeResponse */
export interface AttendanceCodeResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  /** In School */
  in_school: boolean;
  /** Is Present */
  is_present: boolean;
  /** Order */
  order: number;
  /**
   * Code
   * @default ""
   */
  code?: string;
  /**
   * Description
   * @default ""
   */
  description?: string;
  /**
   * Has Push Notifications
   * @default false
   */
  has_push_notifications?: boolean;
  /**
   * Has Justification
   * @default false
   */
  has_justification?: boolean;
}

/** AttendanceCodeStatItem */
export interface AttendanceCodeStatItem {
  /** Attendance Code Id */
  attendance_code_id: string | null;
  /** Order */
  order: number;
  /** Count */
  count: number;
}

/** AttendanceCountsItem */
export interface AttendanceCountsItem {
  /**
   * Register Id
   * @format uuid
   */
  register_id: string;
  /**
   * Group Id
   * @format uuid
   */
  group_id: string;
  /**
   * Register Date
   * @format date
   */
  register_date: string;
  /**
   * Tracking Points
   * Every expected tracking point of the group's day, earliest first.
   */
  tracking_points: AttendanceGroupDayTrackingPoint[];
}

/** AttendanceCountsResponse */
export interface AttendanceCountsResponse {
  /** Results */
  results: AttendanceCountsItem[];
}

/** AttendanceDetail */
export interface AttendanceDetail {
  /**
   * Attendance Code Id
   * Attendance code; null counts the unmarked students.
   */
  attendance_code_id: string | null;
  /**
   * Count
   * Students of the point holding this code (never negative).
   */
  count: number;
}

/** AttendanceDetailsDTO */
export interface AttendanceDetailsDTO {
  /** Attendance Code Id */
  attendance_code_id: string | null;
  /** Order */
  order: number;
  /** Count */
  count: number;
  /** Staff counters, with resolved and rejected records folded into ``closed``. */
  justification_counts: JustificationCountersDTO;
}

/** AttendanceEntryComment */
export interface AttendanceEntryComment {
  /** Text */
  text: string;
  creator: AttendanceEntryCommentCreator;
}

/** AttendanceEntryCommentCreator */
export interface AttendanceEntryCommentCreator {
  /**
   * Relation Id
   * @format uuid
   */
  relation_id: string;
  /** Last Name */
  last_name?: string | null;
  /** Given Name */
  given_name?: string | null;
  /** Known As */
  known_as?: string | null;
  title?: TitleChoices | null;
}

/** AttendanceEntryForRelationUpdate */
export interface AttendanceEntryForRelationUpdate {
  /** Attendance Code Id */
  attendance_code_id: string | null;
  /** Updated From Group Id */
  updated_from_group_id?: string | null;
  /** Comment */
  comment?: string | null;
  /** Null for an uncoupled period mark; derived from coupled period_ids when null. An entry with neither session nor period_ids means AM. */
  session?: AttendanceSessionEnum | null;
  /**
   * Period Ids
   * One uncoupled period, or the periods of one coupled (Registration + Lesson) mark shown under several timetable structures.
   */
  period_ids?: string[];
}

/**
 * AttendanceFrequencyInput
 * Frequency configuration for a single age group.
 */
export interface AttendanceFrequencyInput {
  /** Attendance frequency: 'am', 'pm', or 'am_pm' */
  frequency: FrequencyTypeEnum;
  /** AM responsible party: 'tutor' or 'subject_teacher' */
  am_responsible: ResponsibleTypeEnum;
  /** PM responsible party: 'tutor' or 'subject_teacher' (required when frequency is 'pm' or 'am_pm') */
  pm_responsible?: ResponsibleTypeEnum | null;
  /**
   * Per Period Enabled
   * @default false
   */
  per_period_enabled?: boolean;
}

/**
 * AttendanceFrequencyResponse
 * Attendance frequency configuration for a single age group.
 */
export interface AttendanceFrequencyResponse {
  /**
   * Frequency type for attendance configuration.
   *
   * Values:
   *     am: Morning register only
   *     pm: Afternoon register only
   *     am_pm: Both morning and afternoon registers
   */
  frequency: FrequencyTypeEnum;
  /**
   * Who is responsible for taking the register.
   *
   * Values:
   *     tutor: The group's tutor/teacher
   *     subject_teacher: The subject teacher for the period
   */
  am_responsible: ResponsibleTypeEnum;
  pm_responsible?: ResponsibleTypeEnum | null;
  /**
   * Per Period Enabled
   * @default false
   */
  per_period_enabled?: boolean;
}

/** AttendanceGroup */
export interface AttendanceGroup {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  /** Enum containing the types of groups supported */
  type: GroupType;
  /** Staff Preview */
  staff_preview: AttendanceStaffPreview[];
}

/** AttendanceGroupDayTrackingPoint */
export interface AttendanceGroupDayTrackingPoint {
  /** Session of the point; null for a period-only point. */
  session: AttendanceSessionEnum | null;
  /** Period of the point; null for a session-only point. */
  period: TrackingPointPeriod | null;
  /**
   * Attendance Details
   * Per-code student counts of the point.
   */
  attendance_details: AttendanceDetail[];
}

/**
 * AttendanceStaffPreview
 * Attendance-specific preview; title avoids cross-module OpenAPI collisions.
 */
export interface AttendanceStaffPreview {
  /**
   * Relation Id
   * @format uuid
   */
  relation_id: string;
  /** Last Name */
  last_name: string | null;
  /** Given Name */
  given_name: string | null;
  /** Known As */
  known_as: string | null;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** Profile Picture */
  profile_picture: string | null;
  /** Date Of Birth */
  date_of_birth: string | null;
  /** Gender */
  gender: number | null;
  /** Title */
  title: number | null;
}

/**
 * BadRequestErrorResponse
 * Response schema for bad request errors (400) - includes validation and business logic errors
 */
export interface BadRequestErrorResponse {
  /** Reason */
  reason: string;
  /** Errors */
  errors?: ValidationErrorDetail[] | null;
  /** Details */
  details?: Record<string, string> | null;
}

/** BaseJustificationResponse */
export interface BaseJustificationResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  status: JustificationStatus;
  attendance_entry: JustificationAttendanceEntry;
  /** Entries */
  entries?: JustificationSessionEntry[];
  /** Parent Submissions */
  parent_submissions: JustificationSubmission[];
  /** Staff Reasons */
  staff_reasons: JustificationReason[];
  /** Staff Requests */
  staff_requests: JustificationRequest[];
  /** @deprecated */
  parent_submission?: JustificationSubmission | null;
  /** @deprecated */
  staff_reason?: JustificationReason | null;
}

/** Category */
export interface Category {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
}

/**
 * ChildAttendanceResponse
 * One AM or PM half-day mark. Only built for a marked row — see
 * ``ParentAttendanceDayResponse`` for the unmarked/missing-row cases.
 */
export interface ChildAttendanceResponse {
  /**
   * Attendance Code Id
   * @format uuid
   */
  attendance_code_id: string;
  /** Attendance Code Code */
  attendance_code_code: string;
  /** Attendance Code Name */
  attendance_code_name: string;
  status: ParentAttendanceStatus;
  /** Requires Justification */
  requires_justification: boolean;
}

/**
 * ConfigureFrequenciesRequest
 * Request body for PATCH /attendance/frequencies/for-school/{school_id}.
 */
export interface ConfigureFrequenciesRequest {
  /**
   * Age Groups
   * At least one age group is required
   * @minItems 1
   */
  age_groups: AgeGroupFrequencyInput[];
}

/**
 * ConfigureFrequenciesResponse
 * Response body for PATCH /attendance/frequencies/for-school/{school_id}.
 */
export interface ConfigureFrequenciesResponse {
  /** Age Groups */
  age_groups: AgeGroupFrequencyResponse[];
}

/** CreateCodeRequestItem */
export interface CreateCodeRequestItem {
  /**
   * Name
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** Order */
  order: number;
  /**
   * Code
   * @default ""
   */
  code?: string;
  /**
   * Description
   * @default ""
   */
  description?: string;
  /**
   * In School
   * @default false
   */
  in_school?: boolean;
  /**
   * Is Present
   * @default false
   */
  is_present?: boolean;
  /**
   * Has Push Notifications
   * @default false
   */
  has_push_notifications?: boolean;
  /**
   * Has Justification
   * @default false
   */
  has_justification?: boolean;
}

/** CreateCodesResponse */
export interface CreateCodesResponse {
  /** Success */
  success: string;
}

/** CreateFacilitiesRequest */
export interface CreateFacilitiesRequest {
  /**
   * School Id
   * @format uuid
   */
  school_id: string;
  /** Facilities */
  facilities: FacilityItemInput[];
}

/**
 * CreateRegisterGroupIdsRequest
 * Create-shaped group_ids; an auto-add-only create is valid.
 */
export interface CreateRegisterGroupIdsRequest {
  /** Am */
  am?: string[];
  /** Pm */
  pm?: string[];
  /**
   * Periods
   * Optional. An absent value (null) and a present-but-empty array ([]) mean opposite things on edit: absent does not re-evaluate this bucket from this field; empty is the full desired state with no period expectations. A period-named `explicitly_removed` entry re-evaluates that named period even when this field is absent. Create maps absent to empty (no prior state).
   */
  periods?: PeriodGroupsRequest[] | null;
  /** Explicitly Removed */
  explicitly_removed: ExplicitlyRemovedEntryRequest[];
}

/** CreateRegisterRequest */
export interface CreateRegisterRequest {
  /**
   * Register Date
   * @format date
   */
  register_date: string;
  /** Name */
  name?: string | null;
  /** Create-shaped group_ids; an auto-add-only create is valid. */
  group_ids: CreateRegisterGroupIdsRequest;
}

/**
 * CreateTimetableRequest
 * Request DTO for creating a timetable.
 */
export interface CreateTimetableRequest {
  /** Name */
  name: string;
  /**
   * School Id
   * @format uuid
   */
  school_id: string;
  /**
   * Structure Id
   * @format uuid
   */
  structure_id: string;
  /**
   * School Year Id
   * @format uuid
   */
  school_year_id: string;
  /** Slot Allocations */
  slot_allocations?: SlotAllocationInput[] | null;
}

/**
 * CreateTimetableStructureRequest
 * Request DTO for creating a timetable structure.
 */
export interface CreateTimetableStructureRequest {
  /**
   * School Id
   * @format uuid
   */
  school_id: string;
  /** Name */
  name: string;
  /** Age Group Ids */
  age_group_ids: string[];
  /** Weekdays */
  weekdays: WeekdayEnum[];
  /** Periods */
  periods: PeriodInput[];
  /** Time Slots */
  time_slots: TimeSlotInput[];
}

/** CreateTrialRequest */
export interface CreateTrialRequest {
  /** Role */
  role: string;
  /** School Name */
  school_name: string;
  /** Current Systems */
  current_systems: string;
  /** Website */
  website: string;
  /** Given Name */
  given_name: string;
  /** Last Name */
  last_name: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /** Verification Code */
  verification_code: string;
}

/** CreateTrialResponse */
export interface CreateTrialResponse {
  /**
   * Id
   * ID of the created trial application.
   * @format uuid
   */
  id: string;
}

/** DeleteRegisterResponse */
export interface DeleteRegisterResponse {
  /** Success */
  success: string;
  /** Id */
  id: string;
}

/** EditRegisterRequest */
export interface EditRegisterRequest {
  /** Name */
  name?: string | null;
  /** Register Date */
  register_date?: string | null;
  group_ids?: RegisterGroupIdsRequest | null;
}

/** EditRegisterResponse */
export interface EditRegisterResponse {
  /** Success */
  success: string;
  /** Warning */
  warning?: string | null;
}

/** EligibleGroupResponse */
export interface EligibleGroupResponse {
  /**
   * Group Id
   * @format uuid
   */
  group_id: string;
  /** Name */
  name: string;
  /** Enum containing the types of groups supported */
  group_type: GroupType;
  subject: SubjectPreviewResponse | null;
  /** Age Group Entries */
  age_group_entries: AgeGroupEntryResponse[];
  /** Sessions */
  sessions: EligibleGroupSessionResponse[];
  /** Slots */
  slots: EligibleGroupSlotResponse[];
}

/** EligibleGroupSessionResponse */
export interface EligibleGroupSessionResponse {
  /** Register session slot for a mark or grid row (AM or PM only). */
  session: AttendanceSessionEnum;
  /** Scheduled */
  scheduled: boolean;
  /** Explicitly Removed */
  explicitly_removed: boolean;
}

/**
 * EligibleGroupSlotResponse
 * A lesson period this subject group may be placed on (FR-ATT-REG-24).
 */
export interface EligibleGroupSlotResponse {
  /**
   * Period Id
   * @format uuid
   */
  period_id: string;
  /** Scheduled */
  scheduled: boolean;
  /** Explicitly Removed */
  explicitly_removed: boolean;
}

/** EntryCreator */
export interface EntryCreator {
  /**
   * Relation Id
   * @format uuid
   */
  relation_id: string;
  /** Title */
  title: number | null;
  /** Given Name */
  given_name: string | null;
  /** Last Name */
  last_name: string | null;
  /** Known As */
  known_as: string | null;
}

/** EntryForProfile */
export interface EntryForProfile {
  method: AssessmentEntryMethod;
  /** Score */
  score: number | null;
  /** Select List Option Id */
  select_list_option_id: string | null;
  /** Comment */
  comment: string | null;
  creator: EntryCreator | null;
  /** Select List Option Name */
  select_list_option_name?: string | null;
  /** Select List Option Description */
  select_list_option_description?: string | null;
}

/** EntryForSchool */
export interface EntryForSchool {
  method: AssessmentEntryMethod;
  /** Score */
  score: number | null;
  /** Select List Option Id */
  select_list_option_id: string | null;
  /** Comment */
  comment: string | null;
  creator: EntryCreator | null;
}

/**
 * ExplicitlyRemovedEntryRequest
 * One "not for this register" statement (FR-ATT-REG-30).
 *
 * ``session`` alone removes a session expectation, ``period_id`` alone a period expectation,
 * both together a coupled one; at least one is required. On edit, the bucket of the named
 * dimension (``explicitly_removed`` for sessions, ``periods`` for periods) decides whether it
 * is re-evaluated: an empty bucket and an absent one mean opposite things.
 */
export interface ExplicitlyRemovedEntryRequest {
  /**
   * Group Id
   * @format uuid
   */
  group_id: string;
  session?: AttendanceSessionEnum | null;
  /** Period Id */
  period_id?: string | null;
}

/** FacilityDTO */
export interface FacilityDTO {
  /** Id */
  id: string;
  /** School Id */
  school_id: string;
  /** Name */
  name: string;
  type: FacilityTypeEnum;
  /** Used In Timetables */
  used_in_timetables: boolean;
  /** Parent Id */
  parent_id: string | null;
}

/**
 * FacilityItemInput
 * Shared DTO for facility item in create and update requests.
 */
export interface FacilityItemInput {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  type: FacilityTypeEnum;
  /** Parent Id */
  parent_id: string | null;
}

/** FacilityListResponse */
export interface FacilityListResponse {
  /** Facilities */
  facilities: FacilityDTO[];
}

/**
 * FireRegisterData
 * Everything the fire-register PDF/CSV/JSON renderers need, materialized.
 *
 * ``sections`` is the cover-page overview counters (one per section, summed across all
 * groups), in fixed order.
 */
export interface FireRegisterData {
  /** School Name */
  school_name: string;
  /** Register Date */
  register_date: string;
  /** Register session slot for a mark or grid row (AM or PM only). */
  session: AttendanceSessionEnum;
  /** Groups */
  groups: FireRegisterGroupData[];
  /** Sections */
  sections: FireRegisterSectionData[];
}

/**
 * FireRegisterGroupData
 * One page of the fire register: a tutor group (or the "No tutor group" page).
 *
 * ``students_count`` is the count of enrolled students in this tutor group for the register
 * date — a control check that the sum of the four section ``students_count``s must equal.
 * ``sections`` is the four fire-register sections in fixed order (On premises / Incomplete
 * register / Outside / No register), each a ``FireRegisterGroupSection``.
 */
export interface FireRegisterGroupData {
  /** Group Id */
  group_id: string | null;
  /** Group Name */
  group_name: string | null;
  /** Students Count */
  students_count: number;
  /**
   * Age Group Order
   * @default 0
   */
  age_group_order?: number;
  /** Sections */
  sections?: FireRegisterGroupSection[];
}

/**
 * FireRegisterGroupSection
 * One section of a fire-register group page (On premises / Incomplete register /
 * Outside / No register): the student ``students`` plus a precomputed ``students_count`` so
 * consumers (FE, PDF/CSV exporter) need not recompute ``len(students)``. ``students_count`` is
 * derived from ``students`` (never drifts).
 */
export interface FireRegisterGroupSection {
  /** Section Name */
  section_name: string;
  /** Students */
  students?: FireRegisterSectionRow[];
  /** Students Count */
  students_count: number;
}

/** FireRegisterItem */
export interface FireRegisterItem {
  /** Register Id */
  register_id: string;
  /** Group Id */
  group_id: string;
  /** Relation Id */
  relation_id: string;
  /** Student Id */
  student_id: string;
  /** Student Name */
  student_name: string;
  /** Attendance Code Id */
  attendance_code_id?: string | null;
  /** Attendance Code Code */
  attendance_code_code?: string | null;
  /** Attendance Code Description */
  attendance_code_description?: string | null;
  /** In School */
  in_school: boolean;
}

/**
 * FireRegisterSectionData
 * Cover-page overview counter, summed across all groups.
 */
export interface FireRegisterSectionData {
  /** Section Name */
  section_name: string;
  /**
   * Students Count
   * @default 0
   */
  students_count?: number;
}

/**
 * FireRegisterSectionRow
 * A student placed in one of the four fire-register sections.
 *
 * ``attendance_code_name`` + ``source_session`` together form the "Last Known
 * attendance" label (e.g. ``Present · AM``). They are ``None`` for the Missing
 * attendance and No register sections, which carry no last-known mark.
 * ``known_as`` is the student's preferred display name (nullable) — renderers show
 * ``Full Name (Known as)`` when present.
 */
export interface FireRegisterSectionRow {
  /**
   * Relation Id
   * @format uuid
   */
  relation_id: string;
  /** Given Name */
  given_name: string;
  /** Last Name */
  last_name: string;
  /** Known As */
  known_as?: string | null;
  /** Attendance Code Name */
  attendance_code_name?: string | null;
  source_session?: AttendanceSessionEnum | null;
}

/**
 * ForbiddenErrorResponse
 * Response schema for forbidden errors (403)
 */
export interface ForbiddenErrorResponse {
  /** Reason */
  reason: string;
}

/** GetGroupEntriesForDateQuery */
export interface GetGroupEntriesForDateQuery {
  /**
   * Single Date
   * @format date
   */
  single_date: string;
  /** Search Query */
  search_query?: string | null;
}

/** GetGroupEntriesForPeriodQuery */
export interface GetGroupEntriesForPeriodQuery {
  /**
   * Page Size
   * @default 50
   */
  page_size?: number;
  /**
   * Page Number
   * @default 1
   */
  page_number?: number;
  /**
   * Date From
   * @format date
   */
  date_from: string;
  /**
   * Date To
   * @format date
   */
  date_to: string;
  /** Search Query */
  search_query?: string | null;
}

/** GetProfileEntriesByCodeQuery */
export interface GetProfileEntriesByCodeQuery {
  /**
   * Page Size
   * @default 10
   */
  page_size?: number;
  /**
   * Page Number
   * @default 1
   */
  page_number?: number;
  /** Date From */
  date_from?: string | null;
  /** Date To */
  date_to?: string | null;
  /** School Id */
  school_id?: string | null;
}

/** GetProfileOverviewQuery */
export interface GetProfileOverviewQuery {
  /** Date From */
  date_from?: string | null;
  /** Date To */
  date_to?: string | null;
  /** School Id */
  school_id?: string | null;
}

/** GetRelationEntriesQuery */
export interface GetRelationEntriesQuery {
  /**
   * Page Size
   * @default 50
   */
  page_size?: number;
  /**
   * Page Number
   * @default 1
   */
  page_number?: number;
  /** Date From */
  date_from?: string | null;
  /** Date To */
  date_to?: string | null;
}

/** GetTrialsResponse */
export interface GetTrialsResponse {
  /** Results */
  results: TrialApplicationInfo[];
}

/**
 * Group
 * Group assigned to a timetable.
 */
export interface Group {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  /** Student Count */
  student_count: number | null;
  /** Enum containing the types of groups supported */
  type: GroupType;
  subject: Subject | null;
  /** Age Groups */
  age_groups?: AgeGroup[];
}

/** GroupAttendanceAggregateCellMetaResponse */
export interface GroupAttendanceAggregateCellMetaResponse {
  /** Day */
  day: number;
  /** Sessions */
  sessions: AttendanceSessionEnum[];
  /**
   * Register Id
   * @format uuid
   */
  register_id: string;
  /**
   * Register Date
   * @format date
   */
  register_date: string;
  /** Period Id */
  period_id?: string | null;
}

/** GroupAttendanceAggregateCellResponse */
export interface GroupAttendanceAggregateCellResponse {
  meta: GroupAttendanceAggregateCellMetaResponse;
  value: GroupAttendanceAggregateCellValueResponse;
}

/** GroupAttendanceAggregateCellValueResponse */
export interface GroupAttendanceAggregateCellValueResponse {
  justification: AttendanceAggregateJustificationResponse | null;
  absence_request: AbsenceRequest | null;
  /** Attendance Entries */
  attendance_entries: GroupAttendanceAggregateSessionEntryResponse[];
}

/** GroupAttendanceAggregateResponse */
export interface GroupAttendanceAggregateResponse {
  /** Count */
  count: number;
  /** Current Page */
  current_page: number;
  total: GroupAttendanceAggregateTotalResponse;
  /** Rows */
  rows: GroupAttendanceAggregateRowResponse[];
}

/** GroupAttendanceAggregateRowMetaResponse */
export interface GroupAttendanceAggregateRowMetaResponse {
  /**
   * Relation Id
   * @format uuid
   */
  relation_id: string;
}

/** GroupAttendanceAggregateRowResponse */
export interface GroupAttendanceAggregateRowResponse {
  meta: GroupAttendanceAggregateRowMetaResponse;
  /** Cells */
  cells: GroupAttendanceAggregateCellResponse[];
}

/**
 * GroupAttendanceAggregateSessionEntryResponse
 * Group-preview attendance entry.
 */
export interface GroupAttendanceAggregateSessionEntryResponse {
  session: AttendanceSessionEnum | null;
  /** Attendance Code Id */
  attendance_code_id: string | null;
  /**
   * Attendance Entry Id
   * @format uuid
   */
  attendance_entry_id: string;
  /** Comments */
  comments: AttendanceAggregateEntryCommentResponse[];
  /** Register Group List */
  register_group_list: AttendanceAggregateRegisterGroupResponse[];
  latest_change: AttendanceAggregateLatestChangeResponse;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Updated At */
  updated_at: string | null;
}

/** GroupAttendanceAggregateTotalResponse */
export interface GroupAttendanceAggregateTotalResponse {
  /** Week Days */
  week_days: GroupAttendanceAggregateWeekDayResponse[];
}

/** GroupAttendanceAggregateTrackingPointResponse */
export interface GroupAttendanceAggregateTrackingPointResponse {
  session: AttendanceSessionEnum | null;
  period: AttendanceAggregatePeriodResponse | null;
  /** Total Count */
  total_count: number;
  /** Tracked Count */
  tracked_count: number;
}

/** GroupAttendanceAggregateWeekDayResponse */
export interface GroupAttendanceAggregateWeekDayResponse {
  /** Day */
  day: number;
  /** Tracking Points */
  tracking_points: GroupAttendanceAggregateTrackingPointResponse[];
  /** Register Id */
  register_id: string | null;
  /**
   * Register Date
   * @format date
   */
  register_date: string;
}

/** GroupEntriesForDateResponse */
export interface GroupEntriesForDateResponse {
  /**
   * Group Id
   * @format uuid
   */
  group_id: string;
  /**
   * Register Id
   * @format uuid
   */
  register_id: string;
  /** Enterable */
  enterable: boolean;
  /** Relations */
  relations: RegisterForGroupRelationItem[];
  /** Columns */
  columns?: TakeScreenColumnResponse[];
}

/** GroupForAssessmentWithType */
export interface GroupForAssessmentWithType {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  subject: SubjectForGroupResponse | null;
  /** Type */
  type: number;
}

/** GroupPeriodResultItem */
export interface GroupPeriodResultItem {
  /**
   * Relation Id
   * @format uuid
   */
  relation_id: string;
  /** Given Name */
  given_name: string;
  /** Last Name */
  last_name: string;
  /** Known As */
  known_as?: string | null;
  /** Attendance Details */
  attendance_details: AttendanceDetailsDTO[];
}

/**
 * GroupScheduleSlot
 * Schedule slot without group IDs (for group schedule).
 */
export interface GroupScheduleSlot {
  /**
   * Time Slot Id
   * @format uuid
   */
  time_slot_id: string;
  /** Room Id */
  room_id: string | null;
}

/** GroupSummary */
export interface GroupSummary {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  subject: SubjectForGroupResponse | null;
}

/** GroupSummaryWithType */
export interface GroupSummaryWithType {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  subject: SubjectForGroupResponse | null;
  /** Group Type */
  group_type: number;
}

/**
 * GroupWeekdaySchedule
 * Group schedule for a specific weekday.
 */
export interface GroupWeekdaySchedule {
  weekday: WeekdayEnum;
  /** Slots */
  slots: GroupScheduleSlot[];
}

/**
 * GroupWeeklySchedule
 * Group weekly schedule response (simplified).
 */
export interface GroupWeeklySchedule {
  /** Timetable information for schedule responses. */
  timetable: TimetableInfo;
  /** Timetable structure snapshot. */
  structure: TimetableStructureSnapshot;
  /** Schedule */
  schedule: GroupWeekdaySchedule[];
}

/**
 * GroupWithStaffPreview
 * Group with staff preview.
 */
export interface GroupWithStaffPreview {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  /** Enum containing the types of groups supported */
  type: GroupType;
  subject: Subject | null;
  /** Staff Preview */
  staff_preview: SrcModulesTimetablingInterfaceRestDtosTimetablingStaffPreview[];
}

/**
 * GuardianNotificationPreferencesResponse
 * Current notification preferences for a guardian at a school.
 */
export interface GuardianNotificationPreferencesResponse {
  /**
   * Guardian Id
   * @format uuid
   */
  guardian_id: string;
  /**
   * School Id
   * @format uuid
   */
  school_id: string;
  /** Attendance Notifications Enabled */
  attendance_notifications_enabled: boolean;
  /** Push Enabled */
  push_enabled: boolean;
  /** Email Enabled */
  email_enabled: boolean;
  /** Whatsapp Enabled */
  whatsapp_enabled: boolean;
}

/**
 * InternalServerErrorResponse
 * Response schema for internal server errors (500)
 */
export interface InternalServerErrorResponse {
  /** Reason */
  reason: string;
}

/** JustificationActor */
export interface JustificationActor {
  /**
   * Relation Id
   * @format uuid
   */
  relation_id: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** Last Name */
  last_name: string;
  /** Given Name */
  given_name: string;
  /** Known As */
  known_as: string | null;
  title: TitleChoices | null;
}

/** JustificationAttendanceEntry */
export interface JustificationAttendanceEntry {
  /** Id */
  id: string | null;
  /** Code Id */
  code_id: string | null;
  comment?: AttendanceEntryComment | null;
  absence_request?: AbsenceRequest | null;
  register: Register;
  /** Editable */
  editable: boolean;
}

/**
 * JustificationCountersDTO
 * Staff counters, with resolved and rejected records folded into ``closed``.
 */
export interface JustificationCountersDTO {
  /** Pending */
  pending: number;
  /** Submitted */
  submitted: number;
  /** Expired */
  expired: number;
  /** Closed */
  closed: number;
}

/**
 * JustificationCounts
 * Staff-dashboard counters, with terminal outcomes folded into ``closed``.
 */
export interface JustificationCounts {
  /** Pending */
  pending: number;
  /** Submitted */
  submitted: number;
  /** Expired */
  expired: number;
  /** Closed */
  closed: number;
}

/**
 * JustificationDashboardAttendanceEntry
 * One detailed AM/PM grid entry in the staff justification queue.
 */
export interface JustificationDashboardAttendanceEntry {
  /** Attendance Entry Id */
  attendance_entry_id: string | null;
  /** Attendance Code Id */
  attendance_code_id: string | null;
  register: Register;
  /** Register session slot for a mark or grid row (AM or PM only). */
  session: AttendanceSessionEnum;
  /** Period Ids */
  period_ids: string[];
  /** Comments */
  comments: AttendanceEntryComment[];
  absence_request: AbsenceRequest | null;
  /** Register Group List */
  register_group_list: JustificationSessionGroup[];
  latest_change: JustificationDashboardLatestChange | null;
  /** Created At */
  created_at: string | null;
  /** Updated At */
  updated_at: string | null;
}

/** JustificationDashboardLatestChange */
export interface JustificationDashboardLatestChange {
  author?: AttendanceEntryCommentCreator | null;
  /** Updated From Group Id */
  updated_from_group_id?: string | null;
}

/** JustificationForParentResponse */
export interface JustificationForParentResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  status: JustificationStatus;
  attendance_entry: JustificationAttendanceEntry;
  /** Entries */
  entries?: JustificationSessionEntry[];
  /** Parent Submissions */
  parent_submissions: JustificationSubmission[];
  /** Staff Reasons */
  staff_reasons: JustificationReason[];
  /** Staff Requests */
  staff_requests: JustificationRequest[];
  /** @deprecated */
  parent_submission?: JustificationSubmission | null;
  /** @deprecated */
  staff_reason?: JustificationReason | null;
  /**
   * Profile Id
   * @format uuid
   */
  profile_id: string;
  /**
   * Relation Id
   * @format uuid
   */
  relation_id: string;
}

/** JustificationGuardianRelation */
export interface JustificationGuardianRelation {
  /**
   * Relation Id
   * @format uuid
   */
  relation_id: string;
  /** Last Name */
  last_name: string | null;
  /** Given Name */
  given_name: string | null;
  /** Known As */
  known_as: string | null;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** Telephone */
  telephone: string | null;
  /** Email */
  email: string | null;
  /** Primary */
  primary: boolean;
  title: TitleChoices | null;
}

/** JustificationReason */
export interface JustificationReason {
  /** Text */
  text: string;
  /** Created At */
  created_at: string;
  creator: JustificationActor | null;
}

/** JustificationRelation */
export interface JustificationRelation {
  /**
   * Relation Id
   * @format uuid
   */
  relation_id: string;
  /** Last Name */
  last_name: string | null;
  /** Given Name */
  given_name: string | null;
  /** Known As */
  known_as: string | null;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** Profile Picture */
  profile_picture: string | null;
  /** Guardian Relations */
  guardian_relations: JustificationGuardianRelation[];
  /** Title */
  title: number | null;
}

/**
 * JustificationRequest
 * Staff request history is distinct from staff reason history.
 */
export interface JustificationRequest {
  /** Text */
  text: string;
  /** Created At */
  created_at: string;
  creator: JustificationActor | null;
}

/**
 * JustificationSave
 * An exclusive staff justification action.
 */
export type JustificationSave =
  | StaffReasonJustificationSave
  | StaffRequestJustificationSave;

/** JustificationSessionComment */
export interface JustificationSessionComment {
  /** Text */
  text?: string | null;
  creator?: JustificationRelation | null;
  /** Created At */
  created_at?: string | null;
  /** Updated At */
  updated_at?: string | null;
}

/** JustificationSessionEntry */
export interface JustificationSessionEntry {
  /** Frequency */
  frequency?: string | null;
  /** Attendance Code Id */
  attendance_code_id?: string | null;
  /** Attendance Code Code */
  attendance_code_code?: string | null;
  /** Attendance Code Description */
  attendance_code_description?: string | null;
  /** Has Justification */
  has_justification?: boolean | null;
  /** Groups */
  groups: JustificationSessionGroup[];
  /** Comments */
  comments: JustificationSessionComment[];
}

/** JustificationSessionGroup */
export interface JustificationSessionGroup {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
}

/** JustificationSubmission */
export interface JustificationSubmission {
  /** Text */
  text: string;
  /** Submitted At */
  submitted_at: string;
  submitted_by: JustificationActor | null;
}

/** JustificationSubmissionSave */
export interface JustificationSubmissionSave {
  /** Text */
  text: string;
  /**
   * Date From
   * @format date
   */
  date_from: string;
  /**
   * Date To
   * @format date
   */
  date_to: string;
}

/** JustificationsForSchoolResponse */
export interface JustificationsForSchoolResponse {
  /** Results */
  results: SingleJustificationForSchoolResponse[];
  /** Total Pages */
  total_pages: number;
  /** Next Page */
  next_page: number;
  /** Current Page */
  current_page: number;
  /** Previous Page */
  previous_page: number;
  /** Staff-dashboard counters, with terminal outcomes folded into ``closed``. */
  counts: JustificationCounts;
}

/**
 * LegacyUpsertAttendanceEntryForRelationBody
 * Legacy flat request body kept for the /legacy/... route.
 *
 * Preserves the pre-bulk contract: single attendance_code_id, group_id, comment.
 * The legacy handler still dispatches to :class:`LegacyAttendanceComplexUpdateCommand`.
 */
export interface LegacyUpsertAttendanceEntryForRelationBody {
  /**
   * Attendance Code Id
   * @format uuid
   */
  attendance_code_id: string;
  /**
   * Group Id
   * @format uuid
   */
  group_id: string;
  /** Comment */
  comment?: string | null;
}

/** MarkbookData */
export interface MarkbookData {
  category: Category;
  students: StudentsData;
}

/** MarkbookRecord */
export interface MarkbookRecord {
  student: SchoolRelationInfo;
  /** Assessment Entries */
  assessment_entries: AssessmentEntryForMarkbook[];
  /** Subject Average Score */
  subject_average_score?: SubjectAverageScore[];
}

/** Method */
export interface Method {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Method Type */
  method_type: number;
  /** Score Out Of */
  score_out_of: number | null;
  /** Select List Id */
  select_list_id: string | null;
  /** Select List Name */
  select_list_name: string | null;
}

/** MethodForMobile */
export interface MethodForMobile {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Method Type */
  method_type: number;
  /** Score Out Of */
  score_out_of: number | null;
  /** Select List Id */
  select_list_id: string | null;
  /** Select List Name */
  select_list_name: string | null;
  /** Select List Description */
  select_list_description?: string | null;
}

/**
 * ModifyTimetableRequest
 * Request DTO for modifying timetable allocations.
 *
 * Uses replace-based approach: client sends desired state,
 * server calculates what changed (added/removed/modified slots).
 */
export interface ModifyTimetableRequest {
  /** Name */
  name: string;
  /** Slot Allocations */
  slot_allocations: SlotAllocationInput[];
}

/** MyAbsenceNotice */
export interface MyAbsenceNotice {
  /**
   * Absence Request Id
   * @format uuid
   */
  absence_request_id: string;
  /**
   * Child Id
   * @format uuid
   */
  child_id: string;
  /**
   * Start
   * @format date
   */
  start: string;
  /**
   * End
   * @format date
   */
  end: string;
  /** Comment */
  comment: string;
  /** School Ids */
  school_ids: string[];
}

/** MyAbsenceNoticesResponse */
export interface MyAbsenceNoticesResponse {
  /** Notices */
  notices: MyAbsenceNotice[];
}

/** NoStatusCountResponse */
export interface NoStatusCountResponse {
  /** No Status Count */
  no_status_count: number;
}

/** Occurrence */
export interface Occurrence {
  /** Day Of Week */
  day_of_week: number[];
  /** Day Of Month */
  day_of_month: number | null;
  /** Week Of Month */
  week_of_month: number | null;
}

/** PaginatedGroupPeriodResponse */
export interface PaginatedGroupPeriodResponse {
  /** Results */
  results: GroupPeriodResultItem[];
  /** Count */
  count: number;
  /** Current Page */
  current_page: number;
  /** Previous Page */
  previous_page: number;
  /** Next Page */
  next_page: number;
  /** Total Pages */
  total_pages: number;
}

/** PaginatedProfileEntriesResponse */
export interface PaginatedProfileEntriesResponse {
  /** Results */
  results: ProfileEntryItemResponse[];
  /** Count */
  count: number;
  /** Current Page */
  current_page: number;
  /** Previous Page */
  previous_page: number;
  /** Next Page */
  next_page: number;
  /** Total Pages */
  total_pages: number;
}

/** PaginatedRegisterListResponse */
export interface PaginatedRegisterListResponse {
  /** Results */
  results: RegisterSummaryDTO[];
  /** Count */
  count: number;
  /** Current Page */
  current_page: number;
  /** Previous Page */
  previous_page: number;
  /** Next Page */
  next_page: number;
  /** Total Pages */
  total_pages: number;
}

/** PaginatedRelationEntriesResponse */
export interface PaginatedRelationEntriesResponse {
  /** Results */
  results: RelationEntryItemResponse[];
  /** Count */
  count: number;
  /** Current Page */
  current_page: number;
  /** Previous Page */
  previous_page: number;
  /** Next Page */
  next_page: number;
  /** Total Pages */
  total_pages: number;
}

/**
 * ParentAbsenceNoticeResponse
 * One notice per child; ``profile_ids`` is always single-element here.
 */
export interface ParentAbsenceNoticeResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Profile Ids */
  profile_ids: string[];
  /**
   * Start
   * @format date
   */
  start: string;
  /**
   * End
   * @format date
   */
  end: string;
  /** Comment */
  comment: string;
}

/**
 * ParentAttendanceDayResponse
 * One `(profile, date)` calendar day. Served with ``response_model_exclude_unset=True``:
 * ``am_attendance``/``pm_attendance`` are omitted when no grid row exists for that half-day,
 * explicit ``null`` when one exists but is unmarked.
 */
export interface ParentAttendanceDayResponse {
  /**
   * Date
   * @format date
   */
  date: string;
  /**
   * Profile Id
   * @format uuid
   */
  profile_id: string;
  am_attendance?: ChildAttendanceResponse | null;
  pm_attendance?: ChildAttendanceResponse | null;
  absence_notice?: ParentAbsenceNoticeResponse | null;
  justification?: ParentJustificationResponse | null;
}

/** ParentJustificationResponse */
export interface ParentJustificationResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * Profile Id
   * @format uuid
   */
  profile_id: string;
  /**
   * Date
   * @format date
   */
  date: string;
  status: ParentJustificationStatus;
  /** Expires At */
  expires_at?: string | null;
  /** Parent Submissions */
  parent_submissions: JustificationSubmission[];
  /** Staff Reasons */
  staff_reasons: JustificationReason[];
  /** Staff Requests */
  staff_requests: JustificationRequest[];
}

/**
 * PerformTimetableActionRequest
 * Request DTO for performing actions on a timetable (publish/unpublish).
 */
export interface PerformTimetableActionRequest {
  action: TimetablePerformActionEnum;
}

/** Period */
export interface Period {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Start Time */
  start_time: string;
  /** End Time */
  end_time: string;
  type: PeriodTypeEnum;
  /** Name */
  name: string;
  register_session?: RegisterSessionEnum | null;
}

/**
 * PeriodGroupsRequest
 * Groups the client wants tracked on one scheduled period.
 */
export interface PeriodGroupsRequest {
  /**
   * Period Id
   * @format uuid
   */
  period_id: string;
  /** Group Ids */
  group_ids?: string[];
}

/**
 * PeriodInput
 * Input DTO for period definition.
 */
export interface PeriodInput {
  /**
   * Id
   * Period ID (for updates)
   * @format uuid
   */
  id: string;
  /**
   * Start Time
   * Start time in HH:MM format
   * @format time
   */
  start_time: string;
  /**
   * End Time
   * End time in HH:MM format
   * @format time
   */
  end_time: string;
  type: PeriodTypeEnum;
  /**
   * Name
   * Period name
   */
  name: string;
  /** AM/PM register session tag. Only on Lesson/Registration types. At most one 'am' and one 'pm' per structure. */
  register_session?: RegisterSessionEnum | null;
}

/** ProfileCodeCount */
export interface ProfileCodeCount {
  /**
   * Attendance Code Id
   * @format uuid
   */
  attendance_code_id: string;
  /** Attendance Code Name */
  attendance_code_name: string;
  /** In School */
  in_school: boolean;
  /** Is Present */
  is_present: boolean;
  /** Order */
  order: number;
  /** Count */
  count: number;
}

/** ProfileEntryItemResponse */
export interface ProfileEntryItemResponse {
  /**
   * Register Date
   * @format date
   */
  register_date: string;
  justification?: ProfileEntryJustification | null;
}

/**
 * ProfileEntryJustification
 * Mobile justification payload, retaining the mobile status enum.
 */
export interface ProfileEntryJustification {
  /** Id */
  id?: string | null;
  status: JustificationStatus;
  /** Parent Submissions */
  parent_submissions: JustificationSubmission[];
  /** Staff Reasons */
  staff_reasons: JustificationReason[];
  /** Staff Requests */
  staff_requests: JustificationRequest[];
  parent_submission?: JustificationSubmission | null;
  staff_reason?: JustificationReason | null;
}

/** ProvisionDefaultCodesResponse */
export interface ProvisionDefaultCodesResponse {
  /** Success */
  success: string;
  /** Created Count */
  created_count: number;
}

/** ProvisioningSummaryResponse */
export interface ProvisioningSummaryResponse {
  /**
   * Provisioning Id
   * @format uuid
   */
  provisioning_id: string;
  /**
   * Trial Id
   * Trial application ID used for provisioning
   * @format uuid
   */
  trial_id: string;
  /** Status */
  status: string;
  /** Current Stage */
  current_stage: string;
  /** School Name */
  school_name?: string | null;
  /** Config Version */
  config_version?: string | null;
  /** School Id */
  school_id?: string | null;
  /** Ref Date */
  ref_date: string;
  /** Counts */
  counts: Record<string, any>;
  /** Failure Info */
  failure_info?: Record<string, any> | null;
}

/** RecurringState */
export interface RecurringState {
  /** Ends On */
  ends_on: string | null;
  /** Ends After */
  ends_after: number | null;
  /** Recurrence Id */
  recurrence_id: string | null;
  /** Recurrence Name */
  recurrence_name: string | null;
  /** Following Count */
  following_count: number | null;
  repeat_every: RepeatEvery | null;
}

/** RedefineCodeRequest */
export interface RedefineCodeRequest {
  /** Name */
  name?: string | null;
  /** Code */
  code?: string | null;
  /** Description */
  description?: string | null;
  /** In School */
  in_school?: boolean | null;
  /** Is Present */
  is_present?: boolean | null;
  /** Has Push Notifications */
  has_push_notifications?: boolean | null;
  /** Has Justification */
  has_justification?: boolean | null;
  /** Order */
  order?: number | null;
}

/** RedefineCodeResponse */
export interface RedefineCodeResponse {
  /** Success */
  success: string;
}

/** Register */
export interface Register {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * Date
   * @format date
   */
  date: string;
}

/**
 * RegisterAgeGroupEntryResponse
 * One row per (age group, placement) of a register group.
 *
 * Both ``session`` and ``period_id`` are null on the FR-ATT-REG-20 "not tracked" row, whose
 * ``attendance_record_count`` is therefore always 0.
 */
export interface RegisterAgeGroupEntryResponse {
  age_group: AgeGroupPreviewCompositionResponse;
  /** Student Count */
  student_count: number;
  session: AttendanceSessionEnum | null;
  /** Period Id */
  period_id: string | null;
  /**
   * Attendance Record Count
   * Saved marks this row's OWN age group holds at this placement. Rows of one group sum to the group's total without double counting. A coupled expectation is one entry and is counted once. The FR-ATT-REG-20 'not tracked' row (both `session` and `period_id` null) always carries 0.
   */
  attendance_record_count: number;
}

/** RegisterAgeGroupSessionResponse */
export interface RegisterAgeGroupSessionResponse {
  /** Register session slot for a mark or grid row (AM or PM only). */
  session: AttendanceSessionEnum;
  /** Attendance Details */
  attendance_details: AttendanceCodeCountResponse[];
}

/** RegisterCompositionResponse */
export interface RegisterCompositionResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * School Id
   * @format uuid
   */
  school_id: string;
  /**
   * Register Date
   * @format date
   */
  register_date: string;
  /** Groups */
  groups: RegisterGroupResponse[];
  /** Periods */
  periods: RegisterPeriodResponse[];
  /** Warning */
  warning?: string | null;
}

/**
 * RegisterForGroupJustification
 * Justification payload on group/date register rows.
 */
export interface RegisterForGroupJustification {
  /** Id */
  id: string | null;
  status: StaffJustificationStatus;
  /** Parent Submissions */
  parent_submissions: JustificationSubmission[];
  /** Staff Reasons */
  staff_reasons: JustificationReason[];
  /** Staff Requests */
  staff_requests: JustificationRequest[];
}

/** RegisterForGroupRelationItem */
export interface RegisterForGroupRelationItem {
  /**
   * Relation Id
   * @format uuid
   */
  relation_id: string;
  /** Attendance Code Id */
  attendance_code_id?: string | null;
  /** Text */
  text?: string | null;
  /** Creator Relation Id */
  creator_relation_id?: string | null;
  /** Creator Title */
  creator_title?: number | null;
  /** Creator Given Name */
  creator_given_name?: string | null;
  /** Creator Last Name */
  creator_last_name?: string | null;
  /** Creator Known As */
  creator_known_as?: string | null;
  justification?: RegisterForGroupJustification | null;
  /** Session */
  session?: string | null;
  /** Period Id */
  period_id?: string | null;
}

/** RegisterGroupDetachConfirmationResponse */
export interface RegisterGroupDetachConfirmationResponse {
  /** Entries To Delete */
  entries_to_delete: number;
  /** Success */
  success: string;
}

/**
 * RegisterGroupIdsRequest
 * Per-session and per-period inclusion — a group may be in one or both sessions, and/or
 * on any number of periods.
 *
 * ``explicitly_removed`` is declarative (FR-ATT-REG-31): the client sends the full desired
 * state, not a diff, and the server never infers it from the roster. It is therefore
 * **required** with no default — a defaulted empty list would make "omitted" indistinguishable
 * from "clear the panel" and silently wipe it on any roster-only edit.
 *
 * ``am`` / ``pm`` default to ``[]``, so omitting ``am`` inside a present ``group_ids`` object
 * wipes AM. Only ``periods`` distinguishes absent from empty.
 *
 * An edit may empty the register.
 */
export interface RegisterGroupIdsRequest {
  /** Am */
  am?: string[];
  /** Pm */
  pm?: string[];
  /**
   * Periods
   * Optional. An absent value (null) and a present-but-empty array ([]) mean opposite things on edit: absent does not re-evaluate this bucket from this field; empty is the full desired state with no period expectations. A period-named `explicitly_removed` entry re-evaluates that named period even when this field is absent. Create maps absent to empty (no prior state).
   */
  periods?: PeriodGroupsRequest[] | null;
  /** Explicitly Removed */
  explicitly_removed: ExplicitlyRemovedEntryRequest[];
}

/** RegisterGroupResponse */
export interface RegisterGroupResponse {
  /**
   * Group Id
   * @format uuid
   */
  group_id: string;
  /** Name */
  name: string;
  /** Enum containing the types of groups supported */
  group_type: GroupType;
  subject: SubjectPreviewResponse | null;
  /** Age Group Entries */
  age_group_entries: RegisterAgeGroupEntryResponse[];
  /** Students */
  students: RegisterStudentResponse[];
  /**
   * Sessions
   * The sessions this group's roster entries carry, AM before PM; a group coupled to a period is listed once. BREAKING CHANGE (contract v20): this was an array of objects `{session, attendance_record_count}`. Saved-mark counts moved to `age_group_entries[].attendance_record_count`, which is keyed by placement.
   */
  sessions: RegisterSessionEnum[];
  /**
   * Periods
   * The lesson periods this group's roster entries carry, in timetable order.
   */
  periods: string[];
}

/**
 * RegisterPeriodResponse
 * One lesson period the register was composed against.
 */
export interface RegisterPeriodResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  /** Start Time */
  start_time: string;
  /** End Time */
  end_time: string;
  type: PeriodTypeEnum;
  register_session: RegisterSessionEnum | null;
  /** The timetable structure a scheduled period belongs to. */
  timetable_structure: TimetableStructurePreviewResponse;
}

/** RegisterStatisticsAgeGroupEntryResponse */
export interface RegisterStatisticsAgeGroupEntryResponse {
  age_group: AgeGroupPreviewCompositionResponse;
  /** Sessions */
  sessions: RegisterAgeGroupSessionResponse[];
  /** Staff counters, with resolved and rejected records folded into ``closed``. */
  justification_counts: JustificationCountersDTO;
}

/**
 * RegisterStatisticsResponse
 * Register-level attendance breakdown, aggregated by age group across the whole register.
 */
export interface RegisterStatisticsResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * Date
   * @format date
   */
  date: string;
  /** Age Group Entries */
  age_group_entries: RegisterStatisticsAgeGroupEntryResponse[];
}

/** RegisterStudentResponse */
export interface RegisterStudentResponse {
  /**
   * Relation Id
   * @format uuid
   */
  relation_id: string;
  /** Last Name */
  last_name: string | null;
  /** Given Name */
  given_name: string | null;
  /** Known As */
  known_as: string | null;
  /** Age Group Id */
  age_group_id: string | null;
}

/** RegisterSummaryDTO */
export interface RegisterSummaryDTO {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name?: string | null;
  /**
   * Register Date
   * @format date
   */
  register_date: string;
  /** Entry Count */
  entry_count: number;
  /** Created At */
  created_at: string;
  /** Staff counters, with resolved and rejected records folded into ``closed``. */
  justification_counts: JustificationCountersDTO;
  /** Attendance Details */
  attendance_details?: AttendanceCodeCountResponse[];
  /** Sessions */
  sessions?: RegisterSummarySessionDTO[];
}

/**
 * RegisterSummarySessionDTO
 * Per-session tracked-group count for a register list row (TR-11126).
 */
export interface RegisterSummarySessionDTO {
  /** Register session slot for a mark or grid row (AM or PM only). */
  session: AttendanceSessionEnum;
  /** Group Count */
  group_count: number;
}

/** RelationAttendanceAggregateCellResponse */
export interface RelationAttendanceAggregateCellResponse {
  meta: AttendanceAggregateCellMetaResponse;
  value: RelationAttendanceAggregateCellValueResponse;
}

/** RelationAttendanceAggregateCellValueResponse */
export interface RelationAttendanceAggregateCellValueResponse {
  justification: AttendanceAggregateJustificationResponse | null;
  register: RelationAttendanceAggregateRegisterPreviewResponse | null;
  am: RelationAttendanceAggregateSessionEntryResponse | null;
  pm: RelationAttendanceAggregateSessionEntryResponse | null;
}

/** RelationAttendanceAggregateCountResponse */
export interface RelationAttendanceAggregateCountResponse {
  /** Attendance Code Id */
  attendance_code_id: string | null;
  /** Count */
  count: number;
}

/** RelationAttendanceAggregateRegisterPreviewResponse */
export interface RelationAttendanceAggregateRegisterPreviewResponse {
  /**
   * Date
   * @format date
   */
  date: string;
  /**
   * Id
   * @format uuid
   */
  id: string;
}

/** RelationAttendanceAggregateResponse */
export interface RelationAttendanceAggregateResponse {
  total: RelationAttendanceAggregateTotalResponse;
  /** Rows */
  rows: RelationAttendanceAggregateRowResponse[];
}

/** RelationAttendanceAggregateRowMetaResponse */
export interface RelationAttendanceAggregateRowMetaResponse {
  /**
   * Start Date
   * @format date
   */
  start_date: string;
  /**
   * End Date
   * @format date
   */
  end_date: string;
  /** Week Number */
  week_number: number;
}

/** RelationAttendanceAggregateRowResponse */
export interface RelationAttendanceAggregateRowResponse {
  meta: RelationAttendanceAggregateRowMetaResponse;
  /** Cells */
  cells: RelationAttendanceAggregateCellResponse[];
}

/**
 * RelationAttendanceAggregateSessionEntryResponse
 * Session entry of the student preview, which may span several groups.
 */
export interface RelationAttendanceAggregateSessionEntryResponse {
  /** Attendance Code Id */
  attendance_code_id: string | null;
  /**
   * Attendance Entry Id
   * @format uuid
   */
  attendance_entry_id: string;
  /** Comments */
  comments: AttendanceAggregateEntryCommentResponse[];
  absence_request: AbsenceRequest | null;
  /** Register Group List */
  register_group_list: AttendanceAggregateRegisterGroupResponse[];
  latest_change: AttendanceAggregateLatestChangeResponse;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Updated At */
  updated_at: string | null;
}

/** RelationAttendanceAggregateTotalResponse */
export interface RelationAttendanceAggregateTotalResponse {
  /** Counts */
  counts: RelationAttendanceAggregateCountResponse[];
  /** Staff-dashboard counters, with terminal outcomes folded into ``closed``. */
  justification_counts: JustificationCounts;
  /** Week Days */
  week_days: number[];
}

/** RelationEntriesResponse */
export interface RelationEntriesResponse {
  /** Counts */
  counts: AttendanceDetailsDTO[];
  entries: PaginatedRelationEntriesResponse;
  /** Staff-dashboard counters, with terminal outcomes folded into ``closed``. */
  justification_counts: JustificationCounts;
}

/** RelationEntryItemResponse */
export interface RelationEntryItemResponse {
  /**
   * Register Id
   * @format uuid
   */
  register_id: string;
  /** Register Name */
  register_name: string;
  /** Register Date */
  register_date: string;
  /**
   * Group Id
   * @format uuid
   */
  group_id: string;
  /** Group Name */
  group_name?: string | null;
  /** Group Type */
  group_type?: number | null;
  /** Subject Id */
  subject_id?: string | null;
  /** Subject Name */
  subject_name?: string | null;
  /** Subject Archive */
  subject_archive?: boolean | null;
  /** Attendance Code Id */
  attendance_code_id?: string | null;
  /** Attendance Entry Id */
  attendance_entry_id?: string | null;
  /**
   * Editable
   * @default false
   */
  editable?: boolean;
  /** Text */
  text?: string | null;
  /** Creator Relation Id */
  creator_relation_id?: string | null;
  /** Creator Title */
  creator_title?: number | null;
  /** Creator Given Name */
  creator_given_name?: string | null;
  /** Creator Last Name */
  creator_last_name?: string | null;
  /** Creator Known As */
  creator_known_as?: string | null;
  justification?: RelationEntryJustification | null;
  /** Absence Request */
  absence_request?: Record<string, any> | null;
}

/**
 * RelationEntryJustification
 * Justification payload on relation entry rows.
 */
export interface RelationEntryJustification {
  /** Id */
  id: string | null;
  status: StaffJustificationStatus;
  /** Parent Submissions */
  parent_submissions: JustificationSubmission[];
  /** Staff Reasons */
  staff_reasons: JustificationReason[];
  /** Staff Requests */
  staff_requests: JustificationRequest[];
}

/** RelationTrackingPointsAggregateCellResponse */
export interface RelationTrackingPointsAggregateCellResponse {
  session: AttendanceSessionEnum | null;
  /** Period Id */
  period_id: string | null;
  register: RelationAttendanceAggregateRegisterPreviewResponse | null;
  /** Attendance Code Id */
  attendance_code_id: string | null;
  /**
   * Attendance Entry Id
   * @format uuid
   */
  attendance_entry_id: string;
  /** Comments */
  comments: AttendanceAggregateEntryCommentResponse[];
  /** Register Group List */
  register_group_list: AttendanceAggregateRegisterGroupResponse[];
  latest_change: AttendanceAggregateLatestChangeResponse;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Updated At */
  updated_at: string | null;
}

/** RelationTrackingPointsAggregateColumnResponse */
export interface RelationTrackingPointsAggregateColumnResponse {
  session: AttendanceSessionEnum | null;
  period: AttendanceAggregatePeriodResponse | null;
}

/** RelationTrackingPointsAggregateCountResponse */
export interface RelationTrackingPointsAggregateCountResponse {
  /** Attendance Code Id */
  attendance_code_id: string | null;
  /** Count */
  count: number;
}

/** RelationTrackingPointsAggregateResponse */
export interface RelationTrackingPointsAggregateResponse {
  /** Count */
  count: number;
  /** Current Page */
  current_page: number;
  total: RelationTrackingPointsAggregateTotalResponse;
  /** Weeks */
  weeks: RelationTrackingPointsAggregateWeekResponse[];
}

/** RelationTrackingPointsAggregateRowResponse */
export interface RelationTrackingPointsAggregateRowResponse {
  /**
   * Date
   * @format date
   */
  date: string;
  /** Cells */
  cells: RelationTrackingPointsAggregateCellResponse[];
  justification: AttendanceAggregateJustificationResponse | null;
  absence_request: AbsenceRequest | null;
}

/** RelationTrackingPointsAggregateTotalResponse */
export interface RelationTrackingPointsAggregateTotalResponse {
  /** Session Counts */
  session_counts: RelationTrackingPointsAggregateCountResponse[];
  /** Staff-dashboard counters, with terminal outcomes folded into ``closed``. */
  justification_counts: JustificationCounts;
}

/** RelationTrackingPointsAggregateWeekResponse */
export interface RelationTrackingPointsAggregateWeekResponse {
  /**
   * Start
   * @format date
   */
  start: string;
  /**
   * End
   * @format date
   */
  end: string;
  /** Tracking Points */
  tracking_points: RelationTrackingPointsAggregateColumnResponse[];
  /** Rows */
  rows: RelationTrackingPointsAggregateRowResponse[];
}

/** ReorderCodeItem */
export interface ReorderCodeItem {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Order */
  order: number;
}

/** ReorderCodesResponse */
export interface ReorderCodesResponse {
  /** Success */
  success: string;
}

/** RepeatEvery */
export interface RepeatEvery {
  /** Repeat Count */
  repeat_count: number | null;
  /** Period */
  period: string | null;
  occurrence: Occurrence | null;
}

/** ReportSummary */
export interface ReportSummary {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  /** Status */
  status: number;
}

/**
 * Room
 * Room in a timetable.
 */
export interface Room {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
}

/**
 * ScheduleFacilityDTO
 * Facility referenced by schedule allocations.
 */
export interface ScheduleFacilityDTO {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * School Id
   * @format uuid
   */
  school_id: string;
  /** Name */
  name: string;
  type: FacilityTypeEnum;
  /** Parent Id */
  parent_id: string | null;
}

/**
 * ScheduleSlot
 * Schedule slot with allocations.
 */
export interface ScheduleSlot {
  /**
   * Time Slot Id
   * @format uuid
   */
  time_slot_id: string;
  /** Allocations */
  allocations: ScheduleSlotAllocationEntry[];
}

/**
 * ScheduleSlotAllocationEntry
 * Allocation entry in a schedule slot (for staff/student schedule).
 */
export interface ScheduleSlotAllocationEntry {
  /**
   * Group Id
   * @format uuid
   */
  group_id: string;
  /** Room Id */
  room_id: string | null;
}

/**
 * SchedulerActionResponse
 * Response model for scheduler start/stop actions.
 */
export interface SchedulerActionResponse {
  /**
   * Status
   * Action status: 'started' or 'stopped'
   */
  status: string;
}

/**
 * SchedulerStatusResponse
 * Scheduler status information.
 */
export interface SchedulerStatusResponse {
  /**
   * Running
   * Whether the scheduler is currently running
   */
  running: boolean;
}

/** SchoolRelationInfo */
export interface SchoolRelationInfo {
  /** User Id */
  user_id: string;
  /** Relation Id */
  relation_id: string;
  /** Given Name */
  given_name: string;
  /** Last Name */
  last_name: string;
  /** Title */
  title: number | null;
  /** Known As */
  known_as: string | null;
  /** Profile Picture */
  profile_picture: string | null;
  /** Date Of Birth */
  date_of_birth: string | null;
  /** Gender */
  gender: number | null;
}

/** SchoolReportPerCodeTotal */
export interface SchoolReportPerCodeTotal {
  /** Attendance Code Id */
  attendance_code_id?: string | null;
  /** Attendance Code Code */
  attendance_code_code?: string | null;
  /** Count */
  count: number;
}

/** SchoolReportPerGroupSummary */
export interface SchoolReportPerGroupSummary {
  /** Group Id */
  group_id: string;
  /** Group Name */
  group_name: string;
  /** Total Entries */
  total_entries: number;
  /** Authorised Count */
  authorised_count: number;
  /** Unauthorised Count */
  unauthorised_count: number;
  /** Attendance Percentage */
  attendance_percentage: number;
}

/** SchoolReportResponse */
export interface SchoolReportResponse {
  /** Overall Percentage */
  overall_percentage: number;
  /**
   * Per Group Summaries
   * @default []
   */
  per_group_summaries?: SchoolReportPerGroupSummary[];
  /**
   * Per Code Totals
   * @default []
   */
  per_code_totals?: SchoolReportPerCodeTotal[];
}

/** SchoolStatisticsJustificationCounts */
export interface SchoolStatisticsJustificationCounts {
  /** Pending */
  pending: number;
  /** Submitted */
  submitted: number;
  /** Expired */
  expired: number;
  /** Closed */
  closed: number;
}

/** SchoolStatisticsPeriod */
export interface SchoolStatisticsPeriod {
  /** Period */
  period: AttendanceCodeStatItem[];
  /** Today */
  today: AttendanceCodeStatItem[];
}

/** SchoolStatisticsResponse */
export interface SchoolStatisticsResponse {
  /** Register Count */
  register_count: number;
  statistic: SchoolStatisticsPeriod;
  justification_counts: SchoolStatisticsJustificationCounts;
}

/**
 * SetTimeRequest
 * Request model for setting server time.
 */
export interface SetTimeRequest {
  /**
   * New Time
   * New server time in format 'YYYY-MM-DD HH:MM:SS'. Required if reset is false.
   */
  new_time?: string | null;
  /**
   * Reset
   * If true, reset server time to actual current time.
   * @default false
   */
  reset?: boolean;
  /**
   * Start Scheduler
   * If true, automatically start scheduler after setting time (or stop if resetting).
   * @default false
   */
  start_scheduler?: boolean;
}

/** SingleAssessmentGroupSummary */
export interface SingleAssessmentGroupSummary {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  subject: SubjectForGroupResponse | null;
  /** Group Type */
  group_type: number;
  /** Student Count */
  student_count: number;
}

/** SingleAssessmentGroupWithStudents */
export interface SingleAssessmentGroupWithStudents {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  subject: SubjectForGroupResponse | null;
  /** Type */
  type: number;
  /** Students */
  students: StudentForGroup[];
}

/** SingleAssessmentResponse */
export interface SingleAssessmentResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  /**
   * Assessment Date
   * @format date
   */
  assessment_date: string;
  /** Status */
  status: number;
  /** Display Name */
  display_name: string | null;
  /** Publish Date */
  publish_date: string | null;
  /** Autogenerated */
  autogenerated: boolean;
  /** Can Be Edited */
  can_be_edited: boolean;
  /** Generated From Report Id */
  generated_from_report_id: string | null;
  evaluation_type: AssessmentEvaluationType;
  area_of_learning: AreaOfLearning | null;
  /** Groups */
  groups: GroupSummaryWithType[];
  /** Reports */
  reports: ReportSummary[];
  /** Methods */
  methods: Method[];
  recurring_state: RecurringState | null;
  creator?: EntryCreator | null;
}

/** SingleJustificationForSchoolResponse */
export interface SingleJustificationForSchoolResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  status: StaffJustificationStatus;
  /** Attendance Entries */
  attendance_entries: JustificationDashboardAttendanceEntry[];
  /** Groups */
  groups: AttendanceGroup[];
  relation: JustificationRelation;
  /** Parent Submissions */
  parent_submissions: JustificationSubmission[];
  /** Staff Reasons */
  staff_reasons: JustificationReason[];
  /** Staff Requests */
  staff_requests: JustificationRequest[];
}

/**
 * SlotAllocation
 * Slot allocation in a timetable.
 */
export interface SlotAllocation {
  weekday: WeekdayEnum;
  /**
   * Time Slot Id
   * @format uuid
   */
  time_slot_id: string;
  /** Allocations */
  allocations: AllocationEntry[];
}

/**
 * SlotAllocationEntry
 * Input DTO for single group allocation within a time slot.
 */
export interface SlotAllocationEntry {
  /**
   * Group Id
   * @format uuid
   */
  group_id: string;
  /** Room Id */
  room_id: string | null;
}

/**
 * SlotAllocationInput
 * Input DTO for slot allocation.
 */
export interface SlotAllocationInput {
  /**
   * Time Slot Id
   * @format uuid
   */
  time_slot_id: string;
  /** Allocations */
  allocations: SlotAllocationEntry[];
}

/** StaffReason */
export interface StaffReason {
  /** Text */
  text: string;
  /**
   * Creator Relation Id
   * @format uuid
   */
  creator_relation_id: string;
}

/** StaffReasonJustificationSave */
export interface StaffReasonJustificationSave {
  staff_reason: StaffReason;
}

/** StaffRequest */
export interface StaffRequest {
  /** Text */
  text: string;
  /**
   * Creator Relation Id
   * @format uuid
   */
  creator_relation_id: string;
}

/** StaffRequestJustificationSave */
export interface StaffRequestJustificationSave {
  staff_request: StaffRequest;
}

/** StudentForGroup */
export interface StudentForGroup {
  /**
   * Relation Id
   * @format uuid
   */
  relation_id: string;
  /** Entries */
  entries: EntryForSchool[];
}

/** StudentReportPerCodeBreakdown */
export interface StudentReportPerCodeBreakdown {
  /** Attendance Code Id */
  attendance_code_id?: string | null;
  /** Attendance Code Code */
  attendance_code_code?: string | null;
  /** Count */
  count: number;
}

/** StudentReportResponse */
export interface StudentReportResponse {
  /** Attendance Percentage */
  attendance_percentage: number;
  /** Authorised Count */
  authorised_count: number;
  /** Unauthorised Count */
  unauthorised_count: number;
  /** Late Count */
  late_count: number;
  /**
   * Per Code Breakdown
   * @default []
   */
  per_code_breakdown?: StudentReportPerCodeBreakdown[];
}

/** StudentsData */
export interface StudentsData {
  /** Count */
  count: number;
  /** Current Page */
  current_page: number;
  /** Next Page */
  next_page: number | null;
  /** Previous Page */
  previous_page: number | null;
  /** Total Pages */
  total_pages: number;
  /** Results */
  results: MarkbookRecord[];
}

/**
 * Subject
 * Subject information for a group.
 */
export interface Subject {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
}

/**
 * SubjectAverageScore
 * Per-(subject, group) average score for a student (percentage, 0-100). subject_id is None for tutor groups.
 */
export interface SubjectAverageScore {
  /** Subject Id */
  subject_id: string | null;
  /**
   * Group Id
   * @format uuid
   */
  group_id: string;
  /** Average Score */
  average_score: number | null;
}

/** SubjectForAssessmentFilters */
export interface SubjectForAssessmentFilters {
  /** Id */
  id?: string | null;
  /** Name */
  name?: string | null;
}

/** SubjectForGroupResponse */
export interface SubjectForGroupResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  /** Archived */
  archived: boolean;
}

/** SubjectPreviewResponse */
export interface SubjectPreviewResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
}

/** SubmitAbsenceRequestBody */
export interface SubmitAbsenceRequestBody {
  /**
   * Child Id
   * @format uuid
   */
  child_id: string;
  /**
   * Start
   * @format date
   */
  start: string;
  /**
   * End
   * @format date
   */
  end: string;
  /** Comment */
  comment: string;
  /**
   * School Ids
   * @minItems 1
   */
  school_ids: string[];
}

/** SubmitAbsenceRequestResponse */
export interface SubmitAbsenceRequestResponse {
  /** Success */
  success: string;
  /** Affected School Ids */
  affected_school_ids: string[];
}

/** SubmitParentAbsenceRequestBody */
export interface SubmitParentAbsenceRequestBody {
  /**
   * School Id
   * @format uuid
   */
  school_id: string;
  /**
   * Profile Ids
   * @minItems 1
   */
  profile_ids: string[];
  /**
   * Date From
   * @format date
   */
  date_from: string;
  /**
   * Date To
   * @format date
   */
  date_to: string;
  /** Comment */
  comment: string;
}

/**
 * SuccessResponse
 * Generic success response.
 */
export interface SuccessResponse {
  /**
   * Success
   * @default "ok"
   */
  success?: string;
}

/**
 * TakeScreenColumnResponse
 * One column on the take-attendance screen (response shape).
 */
export interface TakeScreenColumnResponse {
  /** Session */
  session?: string | null;
  /** Period Id */
  period_id?: string | null;
}

/**
 * TimeResponse
 * Response model for time-related endpoints.
 */
export interface TimeResponse {
  /**
   * Server Time
   * Current server time in format 'YYYY-MM-DD HH:MM:SS'
   */
  server_time: string;
  /**
   * Timetravel Status
   * Status of time travel: 'active' or 'disabled'
   */
  timetravel_status: string;
}

/** TimeSlot */
export interface TimeSlot {
  /**
   * Id
   * Time slot template ID (repeated across weekdays)
   * @format uuid
   */
  id: string;
  /** Weekday instance for this slot */
  weekday: WeekdayEnum;
  /** Start Time */
  start_time: string;
  /** End Time */
  end_time: string;
  /**
   * Period Id
   * References Period.id
   * @format uuid
   */
  period_id: string;
}

/**
 * TimeSlotInput
 * Input DTO for time slot definition.
 */
export interface TimeSlotInput {
  /**
   * Id
   * Time slot ID (for updates)
   */
  id?: string | null;
  weekday: WeekdayEnum;
  /**
   * Period Id
   * Reference to Period
   * @format uuid
   */
  period_id: string;
  /**
   * Start Time
   * Start time in HH:MM format
   * @format time
   */
  start_time: string;
  /**
   * End Time
   * End time in HH:MM format
   * @format time
   */
  end_time: string;
}

/**
 * TimetableDetailResponse
 * Response for GET /timetables/{timetable_id} endpoint.
 */
export interface TimetableDetailResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  /**
   * School Year Id
   * @format uuid
   */
  school_year_id: string;
  /** Timetable structure snapshot. */
  structure: TimetableStructureSnapshot;
  /** Groups */
  groups: Group[];
  /** Rooms */
  rooms: Room[];
  /** Slot Allocations */
  slot_allocations: SlotAllocation[];
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Published At */
  published_at: string | null;
}

/**
 * TimetableInfo
 * Timetable information for schedule responses.
 */
export interface TimetableInfo {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
}

/**
 * TimetableListItem
 * Timetable list item for GET /timetables response.
 */
export interface TimetableListItem {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  /**
   * Structure Id
   * @format uuid
   */
  structure_id: string;
  /**
   * School Year Id
   * @format uuid
   */
  school_year_id: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Published At */
  published_at: string | null;
}

/** TimetableStructureDetailResponse */
export interface TimetableStructureDetailResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  /** Age Group Ids */
  age_group_ids: string[];
  /** Weekdays */
  weekdays: WeekdayEnum[];
  /** Time Slots */
  time_slots: TimeSlot[];
  /** Periods */
  periods: Period[];
  /** Timetable Usage */
  timetable_usage: TimetableUsage[];
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/**
 * TimetableStructureIdResponse
 * Response DTO for creating a timetable structure.
 */
export interface TimetableStructureIdResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
}

/** TimetableStructureItem */
export interface TimetableStructureItem {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  /** Age Group Ids */
  age_group_ids: string[];
  /** Weekdays */
  weekdays: WeekdayEnum[];
  /** Time Slots */
  time_slots: TimeSlot[];
  /** Periods */
  periods: Period[];
  /** Timetable Usage */
  timetable_usage: TimetableUsage[];
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/**
 * TimetableStructurePreviewResponse
 * The timetable structure a scheduled period belongs to.
 */
export interface TimetableStructurePreviewResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
}

/**
 * TimetableStructureSnapshot
 * Timetable structure snapshot.
 */
export interface TimetableStructureSnapshot {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Name */
  name: string;
  /** Age Group Ids */
  age_group_ids: string[];
  /** Weekdays */
  weekdays: WeekdayEnum[];
  /** Time Slots */
  time_slots: TimeSlot[];
  /** Periods */
  periods: Period[];
  /** Timetable Usage */
  timetable_usage: TimetableUsage[];
}

/** TimetableStructuresResponse */
export interface TimetableStructuresResponse {
  /** Results */
  results: TimetableStructureItem[];
}

/** TimetableUsage */
export interface TimetableUsage {
  /**
   * School Year Id
   * @format uuid
   */
  school_year_id: string;
  /** Count */
  count: number;
  /** Has Published */
  has_published: boolean;
}

/**
 * TimetablesResponse
 * Response for GET /timetables endpoint.
 */
export interface TimetablesResponse {
  /** Timetables */
  timetables: TimetableListItem[];
  /** Structures */
  structures: TimetableStructureSnapshot[];
}

/** TrackingPointPeriod */
export interface TrackingPointPeriod {
  /**
   * Id
   * Period id: join key for the schedule slot (group_id, weekday(register_date), id).
   * @format uuid
   */
  id: string;
  /**
   * Name
   * Period name from the register's timetable snapshot.
   */
  name: string;
  /**
   * Order
   * 1-based position of the period in its timetable structure.
   */
  order: number;
  /**
   * Timetable Structure Id
   * Timetable structure the period belongs to.
   * @format uuid
   */
  timetable_structure_id: string;
}

/** TrialActionRequest */
export interface TrialActionRequest {
  /**
   * Id
   * @format uuid
   */
  id: string;
  action: TrialAction;
  /** Trial Expiry Date */
  trial_expiry_date?: string | null;
}

/** TrialActionResponse */
export interface TrialActionResponse {
  /**
   * Id
   * ID of the trial application that was updated.
   * @format uuid
   */
  id: string;
}

/** TrialApplicationInfo */
export interface TrialApplicationInfo {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Role */
  role: string;
  /** School Name */
  school_name: string;
  /** Current Systems */
  current_systems: string;
  /** Website */
  website: string | null;
  /** Given Name */
  given_name: string;
  /** Last Name */
  last_name: string;
  /**
   * Email
   * @format email
   */
  email: string;
  /** Status */
  status: TrialApplicationInfoStatusEnum;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
  /** Trial Expiry Date */
  trial_expiry_date?: string | null;
  /** School Id */
  school_id?: string | null;
}

/** UpdateFacilitiesRequest */
export interface UpdateFacilitiesRequest {
  /** Facilities */
  facilities: FacilityItemInput[];
}

/**
 * UpdateGuardianNotificationPreferencesRequest
 * Partial update request for guardian notification preferences.
 *
 * All fields are optional. Only provided fields are updated.
 */
export interface UpdateGuardianNotificationPreferencesRequest {
  /** Attendance Notifications Enabled */
  attendance_notifications_enabled?: boolean | null;
  /** Push Enabled */
  push_enabled?: boolean | null;
  /** Email Enabled */
  email_enabled?: boolean | null;
  /** Whatsapp Enabled */
  whatsapp_enabled?: boolean | null;
}

/**
 * UpdateTimetableStructureRequest
 * Request DTO for updating a timetable structure.
 */
export interface UpdateTimetableStructureRequest {
  /** Name */
  name: string;
  /** Age Group Ids */
  age_group_ids: string[];
  /** Weekdays */
  weekdays: WeekdayEnum[];
  /** Periods */
  periods: PeriodInput[];
  /** Time Slots */
  time_slots: TimeSlotInput[];
}

/** UpsertAttendanceEntryForRelationBody */
export interface UpsertAttendanceEntryForRelationBody {
  /** Entries */
  entries: AttendanceEntryForRelationUpdate[];
  justification?: JustificationSave | null;
}

/**
 * ValidationErrorDetail
 * Detail of a validation error
 */
export interface ValidationErrorDetail {
  /** Loc */
  loc: string[];
  /** Msg */
  msg: string;
  /** Type */
  type: string;
}

/**
 * ValidationErrorResponse
 * Response schema for validation errors (422)
 */
export interface ValidationErrorResponse {
  /** Reason */
  reason: string;
  /** Errors */
  errors: ValidationErrorDetail[];
}

/**
 * WeekdaySchedule
 * Schedule for a specific weekday.
 */
export interface WeekdaySchedule {
  weekday: WeekdayEnum;
  /** Slots */
  slots: ScheduleSlot[];
}

/**
 * WeeklySchedule
 * Weekly schedule response.
 */
export interface WeeklySchedule {
  /** Timetable information for schedule responses. */
  timetable: TimetableInfo;
  /** Timetable structure snapshot. */
  structure: TimetableStructureSnapshot;
  /** Groups */
  groups: GroupWithStaffPreview[];
  /** Facilities */
  facilities: ScheduleFacilityDTO[];
  /** Schedule */
  schedule: WeekdaySchedule[];
}

/** WithdrawAbsenceRequestResponse */
export interface WithdrawAbsenceRequestResponse {
  /** Success */
  success: string;
}

/** StaffPreview */
export interface SrcModulesAssessmentsInterfaceRestDtosAssesmentStaffPreview {
  /**
   * Relation Id
   * @format uuid
   */
  relation_id: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** Last Name */
  last_name: string | null;
  /** Given Name */
  given_name: string | null;
  /** Known As */
  known_as: string | null;
  /** Profile Picture */
  profile_picture: string | null;
  /** Date Of Birth */
  date_of_birth: string | null;
  /** Gender */
  gender: number | null;
}

/**
 * StaffPreview
 * Staff preview information.
 */
export interface SrcModulesTimetablingInterfaceRestDtosTimetablingStaffPreview {
  /**
   * Relation Id
   * @format uuid
   */
  relation_id: string;
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** Last Name */
  last_name: string;
  /** Given Name */
  given_name: string;
  /** Known As */
  known_as: string | null;
  /** Title */
  title: number | null;
}

/**
 * Group Type
 * Group type: 1 for Subject, 2 for TutorGroup
 */
export enum AssessmentAverageResultGroupTypeEnum {
  Value1 = 1,
  Value2 = 2,
}

/** Status */
export enum TrialApplicationInfoStatusEnum {
  Pending = "pending",
  Approved = "approved",
  Rejected = "rejected",
  Deleted = "deleted",
}
